import type {
  GetLikedGoodsRequest,
  GetRankingGoodsRequest,
} from 'shared/src/api';

export const queryKey = {
  homeTabs: () => ['homeTabs'],
  homeIcons: () => ['homeIcons'],
  rankingFilters: () => ['rankingFilters'],
  rankingGoods: (
    params: Omit<GetRankingGoodsRequest, 'last_ranking' | 'last_sno'>,
  ) => ['rankingGoods', params],
  likedGoods: (params: Omit<GetLikedGoodsRequest, 'last_sno'>) => [
    'likedGoods',
    params,
  ],
  likedGoodsCategories: () => ['likedGoodsCategories'],
  marketRankingTypes: () => ['marketRankingTypes'],
  marketRankingFilterOptions: (marketTypeSno: number) => [
    'marketRankingFilterOptions',
    marketTypeSno,
  ],
  marketRankings: (params: {
    market_type_sno: number;
    category_sno?: number;
    age_list?: number[];
    style_list?: string[];
  }) => ['marketRankings', params],
  overviewCategories: () => ['overviewCategories'],
  iconsSummary: () => ['iconsSummary'],
  iconsAll: () => ['iconsAll'],
  retailAd: (adSlotId: number) => ['retailAd', adSlotId],
  favoriteMarkets: () => ['favoriteMarkets'],
  favoriteMarketsWithNewGoods: () => ['favoriteMarketsWithNewGoods'],
  favoriteMarketsFilterOptions: () => ['favoriteMarketsFilterOptions'],
  favoriteMarketsGoods: (params: { order?: string; category_sno?: number }) => [
    'favoriteMarketsGoods',
    params,
  ],
  homePromotionComponents: () => ['homePromotionComponents'],
  folderDetailMeta: (folderSno: number) => ['folderDetailMeta', folderSno],
  folderDetailMetaAll: ['folderDetailMeta'],
  folderDetail: (params: {
    folderSno: number;
    order?: string;
    categorySno?: number;
    deliveryTypeList?: number[];
  }) => ['folderDetail', params],
  folderDetailAll: ['folderDetail'],
  folderDetailCategories: (folderSno: number) => [
    'folderDetailCategories',
    folderSno,
  ],
} as const;
